import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'
import Config from '../../Config'

export const CLAIMS_LOADING = 'CLAIMS_LOADING'
export const CLAIMS_SUCCESS = 'CLAIMS_SUCCESS'
export const CLAIMS_FAILED = 'CLAIMS_FAILED'

export const CLAIMSFILTER_LOADING = 'CLAIMSFILTER_LOADING'
export const CLAIMSFILTER_SUCCESS = 'CLAIMSFILTER_SUCCESS'
export const CLAIMSFILTER_FAILED = 'CLAIMSFILTER_FAILED'

export const CLAIMS_PAGE_CHANGE = 'CLAIMS_PAGE_CHANGE'
export const CLAIMS_PAGE_SIZE = 'CLAIMS_PAGE_SIZE'

export const CLAIMS_STORE_FILTERS = 'CLAIMS_STORE_FILTERS'
export const CLAIMS_STORE_DROPDOWNS = 'CLAIMS_STORE_DROPDOWNS'

export const fetchClaims = (filterObj = {}, pageNum, pageSize) => {
  // As of May 2023, it is expected that startPeriod and endPeriod will always be present and valid in the filters.
  // If they are empty or invalid, it's a bug with the filter implementation.
  const { startPeriod, endPeriod } = filterObj

  let path = `/claims/${NgrxAuth.memberId}/${startPeriod}/${endPeriod}/${pageNum || 1}/${pageSize || Config.defaultPageSize}`
  if (filterObj) {
    if (filterObj.benefit) {
      path = `${path}/${filterObj.benefit}`
    } else {
      path = `${path}/0`
    }

    if (filterObj.members) {
      path = `${path}/${filterObj.members}`
    } else {
      path = `${path}/0`
    }

    if (filterObj.status) {
      path = `${path}/${filterObj.status}`
    } else {
      path = `${path}/0`
    }

    if (filterObj.onlyReceipts) {
      path = `${path}/true?onlyReceipts=${filterObj.onlyReceipts}`
    } else {
      path = `${path}/true?onlyReceipts=false`
    }
  }
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path,
        prefix: 'CLAIMS',
        mock: false,
        method: 'get'
      }
    })
  }
}

export const fetchClaimFilters = (onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/claims/filterCriteria',
        prefix: 'CLAIMSFILTER',
        mock: false,
        onSuccess,
        onError
      }
    })
  }
}

export const storeFilters = (filterObj) => {
  return {
    type: CLAIMS_STORE_FILTERS,
    filterObj
  }
}

export const changePage = (pageNum = 1) => {
  return {
    type: CLAIMS_PAGE_CHANGE,
    pageNum
  }
}

export const changeSize = (pageSize = 20) => {
  return {
    type: CLAIMS_PAGE_SIZE,
    pageSize
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/claimsActions.js